class BarChart {
    constructor(singleChart, options = {}) {
        this.singleChart = singleChart;

        this.settings = {
            type: options.type || 'bar',
            plugins: options.plugins || [ChartDataLabels],

            chart: options.chart || singleChart,
            desktopChartContainer: options.desktopChartContainer || singleChart.querySelector('.chart canvas.desktop'),
            mobileChartContainer: options.mobileChartContainer || singleChart.querySelector('.chart canvas.mobile'),
            chartValues: options.chartValues || singleChart.querySelectorAll('.legend span'),
            axisUnit: options.axisUnit || singleChart.querySelector('.chart').getAttribute('data-axes-unit'), // e.g. %, $, €, ...
            percentageCalc: options.percentageCalc || singleChart.querySelector('.chart').getAttribute('data-percentage-calc'), // true or false
        }

        this.settings.configArray = new ChartJs().getChartValues(this.settings.chartValues, this.settings.percentageCalc);

        /**
         * @desc set data array
         */
        this.data = {
            labels: this.settings.configArray[0],
            datasets: [{
                data: this.settings.configArray[1],
                backgroundColor: this.settings.configArray[2]
            }]
        }

        /**
         * @desc axis config
         */
        this.axis = {
            x: {
                desktop: {
                    display: true,
                    title: {
                        display: true,
                        text: singleChart.querySelector('.chart').getAttribute('data-x-axes-title'),
                        font: {
                            family: 'DINNextLTPro-Bold',
                            weight: 'normal',
                            size: '25px',
                            lineHeight: '55px',
                        },
                        color: '#B19A00',
                    },
                    min: 0,
                    max: parseInt(singleChart.querySelector('.chart').getAttribute('data-axes-max')),
                    ticks: {
                        stepSize: parseInt(singleChart.querySelector('.chart').getAttribute('data-axes-steps')),
                        font: {
                            family: 'Roboto-Light',
                            weight: 'normal',
                            size: '18px',
                            lineHeight: '28px',
                        },
                    },
                    grid: {
                        tickColor: 'rgba(48, 69, 78, .4)',
                        tickLength: 20,
                        borderColor: 'rgba(48, 69, 78, .4)',
                        color: 'rgba(48, 69, 78, .4)',
                    },
                },

                mobile: {
                    display: true,
                    title: {
                        display: false,
                    },
                    min: 0,
                    max: parseInt(singleChart.querySelector('.chart').getAttribute('data-axes-max')),
                    ticks: {
                        stepSize: parseInt(singleChart.querySelector('.chart').getAttribute('data-axes-steps')),
                        font: {
                            family: 'Roboto-Light',
                            weight: 'normal',
                            size: '18px',
                            lineHeight: '28px',
                        }
                    },
                    grid: {
                        tickColor: 'transparent',
                        tickLength: 20,
                        borderColor: 'rgba(48, 69, 78, .4)',
                        color: 'rgba(48, 69, 78, .4)',
                    },
                }
            },

            y: {
                desktop: {
                    display: true,
                    title: {
                        display: true,
                        text: singleChart.querySelector('.chart').getAttribute('data-y-axes-title'),
                        font: {
                            family: 'DINNextLTPro-Bold',
                            weight: 'normal',
                            size: '25px',
                            lineHeight: '55px',
                        },
                        color: '#B19A00',
                    },
                    ticks: {
                        font: {
                            family: 'Roboto-Light',
                            weight: 'normal',
                            size: '18px',
                            lineHeight: '28px',
                        }
                    },
                    grid: {
                        tickColor: 'transparent',
                        tickLength: 20,
                        borderColor: 'rgba(48, 69, 78, .4)',
                        drawOnChartArea: false,
                    }
                },

                mobile: {
                    display: false,
                    grid: {
                        tickColor: 'transparent',
                        tickLength: 10,
                        borderColor: 'rgba(48, 69, 78, .4)',
                        drawOnChartArea: false,
                    }
                }
            }
        }

        /**
         * @desc tooltip config
         */
        this.tooltip = {
            backgroundColor: 'rgb(244, 246, 246)',
            titleColor: '#30454E',
            titleFont: {
                family: 'DINNextLTPro-Bold',
                weight: 'normal',
                size: '16px',
                lineHeight: '16px',
            },
            bodyColor: '#30454E',
            bodyFont: {
                family: 'DINNextLTPro-Bold',
                size: '26px',
                lineHeight: '26px',
            },
            padding: 22,
            caretSize: 0,
            displayColors: false,
            callbacks: {
                label: (value) => new ChartJs().tooltipFormatter(value, this.settings.axisUnit),
            }
        }

        /**
         * @desc datalabels config
         */
        this.datalabels = {
            desktop: {
                formatter: (value, ctx) => new ChartJs().datalabelsFormatter(value, ctx, this.settings.axisUnit),
                font: {
                    family: 'DINNextLTPro-Bold',
                    weight: 'normal',
                    size: '28px',
                    lineHeight: '60px',
                },
                color: '#30454E',
                textAlign: 'center',
                textShadowBlur: 5,
                textShadowColor: '#fff',
                anchor: 'end',
                align: 'right',
                padding: {
                    top: 0,
                    right: 15,
                    bottom: 0,
                    left: 15,
                }
            },
        }

        /**
         * @desc set options array
         */
        this.options = {
            desktop: {
                indexAxis: 'y',
                elements: {
                    bar: {
                        borderRadius: 4,
                    }
                },
                scales: {
                    xAxes: this.axis.x.desktop,
                    yAxes: this.axis.y.desktop,
                },
                plugins: {
                    legend: false,
                    tooltip: this.tooltip,
                    datalabels: this.datalabels.desktop
                }
            },

            mobile: {
                elements: {
                    bar: {
                        borderRadius: 4,
                    }
                },
                scales: {
                    yAxis: this.axis.x.mobile,
                    xAxis: this.axis.y.mobile,
                },
                plugins: {
                    legend: false,
                    tooltip: this.tooltip,
                }
            }
        }

        /**
         * @desc set config array
         */
        this.config = {
            desktop: {
                type: this.settings.type,
                data: this.data,
                options: this.options.desktop,
                plugins: this.settings.plugins
            },

            mobile: {
                type: this.settings.type,
                data: this.data,
                options: this.options.mobile,
            }
        }

        this.initChart();
    }

    /**
     * @desc initialise and config chart
     */
    initChart = () => {

        if (this.singleChart.parentElement.classList.contains('chartjs-container')) {


            this.options.mobile.plugins.tooltip.backgroundColor = '#fff';
            this.options.desktop.plugins.tooltip.backgroundColor = '#fff';

        }

        const windowSizeInit = () => {
            if (window.innerWidth < 1200) {
                let mobileChart = new Chart(this.settings.mobileChartContainer, this.config.mobile);
            } else {
                let desktopChart = new Chart(this.settings.desktopChartContainer, this.config.desktop);
            }
        }

        windowSizeInit()
        window.addEventListener('resize', Event => { windowSizeInit() })
    }
}


// -------------------------------------------------------------- //

if (document.querySelector('.chartjs.bar-chart')) {
    let charts = document.querySelectorAll('.chartjs.bar-chart');

    charts.forEach(singleChart => {
        let barChart = new BarChart(singleChart);
    })
}
